export const __ = (window as any).wp?.i18n?.__? text => (window as any).wp.i18n.__(text, 'coupons-plus-for-woocommerce') : ((text: any) => text);